import { ENDPOINT } from '~/constants';

import { isAbortError, type KyRequestOptions } from '@vestigas/data';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

import { type DocumentsPerProjectResponse } from './types';

/**
 * Fetches the list of documents in a given AI project.
 * @param projectName - The name of the AI project to fetch the documents from.
 * @param options - Request options.
 * @returns The list of documents in the given AI project.
 * @see https://fa-vestigas-dev.azurewebsites.net/docs#/Metadata/get_documents_per_project_get_documents_per_project_get
 */
export const fetchDocumentsPerProject = async (
  projectName: string,
  options?: KyRequestOptions,
) => {
  try {
    const response = await vestigasAiApi
      .get(ENDPOINT.AI.GET_DOCUMENTS_PER_PROJECT(), {
        searchParams: {
          projectName,
        },
        ...options,
      })
      .json<DocumentsPerProjectResponse>();

    return response;
  } catch (error) {
    if (isAbortError(error)) {
      return;
    }

    log.error({
      message: 'Error fetching documents in AI project',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
